import root from '../../selectors';
import { RootState } from '../../../../reducers';

export const selector = (state: RootState) => ({
  initialValues: {
    login: root(state).suggestedLogin,
  },
});
